// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5232":"a40cbad1","5257":"81d31a9f","7322":"6bf98cdd"}[chunkId] + ".chunk.css";
};